/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Finance } from './';
import {
    FinanceFromJSON,
    FinanceFromJSONTyped,
    FinanceToJSON,
} from './';
import type { FinanceType } from './';
import {
    FinanceTypeFromJSON,
    FinanceTypeFromJSONTyped,
    FinanceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface DailyRate
 */
export interface DailyRate extends Finance {
    /**
     * 
     * @type {number}
     * @memberof DailyRate
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyRate
     */
    max?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DailyRate
     */
    communicateRateToFreelancer: boolean;
}

/**
 * Check if a given object implements the DailyRate interface.
 */
export function instanceOfDailyRate(value: object): value is DailyRate {
    if (!('communicateRateToFreelancer' in value) || value['communicateRateToFreelancer'] === undefined) return false;
    return true;
}

export function DailyRateFromJSON(json: any): DailyRate {
    return DailyRateFromJSONTyped(json, false);
}

export function DailyRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRate {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...FinanceFromJSONTyped(json, ignoreDiscriminator),
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
        'communicateRateToFreelancer': json['communicateRateToFreelancer'],
    };
}

export function DailyRateToJSON(value?: DailyRate | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...FinanceToJSON(value, true),
        'min': value['min'],
        'max': value['max'],
        'communicateRateToFreelancer': value['communicateRateToFreelancer'],
    };
}

